import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { PlayCircleOutline } from '@material-ui/icons';

import GalleryCountIcon from './GalleryCountIcon';


const useStyles = makeStyles((theme) => {
  return {
    imageContainer: {
      maxWidth: '60%',
      [theme.breakpoints.down('xl')]: { maxWidth: '50%' },
      [theme.breakpoints.down('lg')]: { maxWidth: '60%' },
      [theme.breakpoints.down('md')]: { maxWidth: '70%' },
      [theme.breakpoints.down('sm')]: { maxWidth: '80%' },
      [theme.breakpoints.down('xs')]: { maxWidth: '100%' },
      '&.video-snapshot': {},
      '& > img': {
        borderRadius: 20,
        display: 'block',
        maxHeight: '30vh',
        maxWidth: '100%',
      },
    },
    pointer: { cursor: 'pointer' },
    imageOverlay: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, .5)',
      color: theme.palette.common.white,
      cursor: 'pointer',
      borderRadius: 20,
    },
    videoIcon: {
      fontSize: 48,
      [theme.breakpoints.down('md')]: { fontSize: 36 },
    },
  };
});

const SharedContentCoverImage = ({ url, isVideoCover, onImageLoad, onClick, galleryImagesCount }) => {
  const classes = useStyles();

  return (
    <Box
      className={`${classes.imageContainer}${isVideoCover ? ' video-snapshot' : ''}`}
      display="inline-block"
      position="relative"
      onClick={onClick}
    >
      <Box
        alignItems={isVideoCover ? 'center' : 'flex-start'}
        className={classes.imageOverlay}
        display="flex"
        justifyContent={isVideoCover ? 'center' : 'flex-end'}
        position="absolute"
        pr={isVideoCover ? 0 : 2}
        pt={isVideoCover ? 0 : 2}
      >
        <Box>
          {isVideoCover ? (
            <PlayCircleOutline className={classes.videoIcon} />
          ) : (
            <GalleryCountIcon count={galleryImagesCount} />
          )}
        </Box>
      </Box>
      <img alt="" loading="lazy" src={url} onLoad={onImageLoad} />
    </Box>
  );
};

export default SharedContentCoverImage;
